/**
 * DCC Module Routes (extracted from index.tsx)
 */
import React from 'react';
import { Result } from 'antd';
import { RouteItem } from './index';
import { HomeOutlined, FormOutlined, OrderedListOutlined, PlusOutlined, FileTextOutlined, TranslationOutlined, FolderOutlined, BookOutlined, FileProtectOutlined, DatabaseOutlined, FileSearchOutlined } from '@ant-design/icons';

// Shared forms
import FormDefinitionsList from "../components/common/Forms/FormDefinitionsList";
import FormDefinitionEditor from "../components/common/Forms/FormDefinitionEditor";
import PdfToReactFormGenerator from "../components/common/Forms/PdfToReactFormGenerator";
import FormRecordDetailsList from '../components/common/Forms/FormRecordDetailsList';

// DCC pages
import DccFormsCreate from "../pages/dcc/forms/DccFormsCreate";
import DccFormFill from "../pages/dcc/forms/DccFormFill";
import DccFormList from "../pages/dcc/forms/DccFormList";
import DccFormEdit from '../pages/dcc/forms/DccFormEdit';
import DccFormView from '../pages/dcc/forms/DccFormView';
import DccFormGroupCreate  from "../pages/dcc/forms/DccFormGroupCreate";
import DccDashboard from "../pages/dcc/DccDashboard";
import DccDocuments from "../pages/dcc/DccDocuments";
import DccOldArchiveFiles from "../pages/dcc/DccOldArchiveFiles";
import DccLocalFiles from "../pages/dcc/DccLocalFiles";
import DccIndexTables from "../pages/dcc/DccIndexTables";
import DccTranslationLog from "../pages/dcc/DccTranslationLog";
import DccTranslationPackages from "../pages/dcc/DccTranslationPackages";
import DccTranslationReturns from "../pages/dcc/DccTranslationReturns";
import DccTranslationRequest from "../pages/dcc/DccTranslationRequest";
import CorOcr from "../pages/core/CorOcr";

const UnderConstruction = ({ title }: { title: string }) => (
  <Result status="info" title={`${title} Module`} subTitle="Under Construction." />
);

export const dccRoutes: Record<string, RouteItem> = {
  // DCC modülü
  dcc: {path: '/dcc', element: null, label: 'DCC', showInMenu: false,
    children: {
      dashboard: {path: '/dcc/dashboard', element: <DccDashboard />, label: 'Dashboard', icon: <HomeOutlined />, showInMenu: true},
      forms: {path: '/dcc/forms', element: <DccFormList/>, label: 'Forms', icon: <FormOutlined />, showInMenu: true,
        grandchildren: {
          list: {path: '/dcc/forms/list', element: <DccFormList/>, label: 'Form List', icon: <OrderedListOutlined />, showInMenu: true},
          definitions: {path: '/dcc/forms/definitions', element: <FormDefinitionsList />, label: 'Form Definitions', icon: <OrderedListOutlined />, showInMenu: true},
          definitions_create: {path: '/dcc/forms/definitions/create', element: <PdfToReactFormGenerator />, label: 'Create Form Definition', showInMenu: false},
          definitions_edit: {path: '/dcc/forms/definitions/edit/:id', element: <FormDefinitionEditor />, label: 'Edit Form Definition', showInMenu: false},
          list_record_details: {path: '/dcc/forms/list_record_details', element: <FormRecordDetailsList />, label: 'Form Record Details', icon: <OrderedListOutlined />, showInMenu: true},
          group: {path: '/dcc/forms/gr_create', element: <DccFormGroupCreate />, label: 'New Form Group', icon: <PlusOutlined />, showInMenu: true},
          create: {path: '/dcc/forms/create', element: <DccFormsCreate/>, label: 'Create Form', icon: <PlusOutlined />, showInMenu: true},
          fill: {path: '/dcc/forms/fill', element: <DccFormFill/>, label: 'Fill Form',  showInMenu: true},
          edit: {path: '/dcc/forms/edit/:id', element: <DccFormEdit />, label: 'Edit Form', showInMenu: false},
          view: {path: '/dcc/forms/view/:id', element: <DccFormView />, label: 'View Form', showInMenu: false},
        },
      },
      correspondences: {path: '/dcc/correspondences', element: <UnderConstruction title="Correspondences" />, label: 'Correspondences', icon: <FileTextOutlined />, showInMenu: false},
      translation: {
        path: '/dcc/translation',
        element: <DccTranslationLog />,
        label: 'Translation',
        icon: <TranslationOutlined />,
        showInMenu: true,
        grandchildren: {
          log: { path: '/dcc/translation/log', element: <DccTranslationLog />, label: 'Log', showInMenu: true },
          request: { path: '/dcc/translation/request', element: <DccTranslationRequest />, label: 'Request', showInMenu: true },
          packages: { path: '/dcc/translation/packages', element: <DccTranslationPackages />, label: 'Packages', showInMenu: true },
          returns: { path: '/dcc/translation/returns', element: <DccTranslationReturns />, label: 'Returns', showInMenu: true },
        },
      },
      documents: {path: '/dcc/documents', element: <DccDocuments />, label: 'DCC Documents', icon: <FolderOutlined />, showInMenu: true},
      old_archive: {path: '/dcc/old-archive', element: <DccOldArchiveFiles />, label: 'Old Archive Files', icon: <FileProtectOutlined />, showInMenu: true},
      local_files: {path: '/dcc/local-files', element: <DccLocalFiles />, label: 'Local Files (Browser)', icon: <FolderOutlined />, showInMenu: true},
      index_tables: {path: '/dcc/index-tables', element: <DccIndexTables />, label: 'DCC Folder Index Tables', icon: <DatabaseOutlined />, showInMenu: true},
      ocr: {path: '/dcc/ocr', element: <CorOcr />, label: 'OCR', labelKey: 'routes.dcc.ocr', icon: <FileSearchOutlined />, showInMenu: true},
      library: {path: '/dcc/library', element: <UnderConstruction title="Library" />, label: 'Library', icon: <BookOutlined />, showInMenu: false},
    },
  },
};
